import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";
import { Stage } from "react-migration/domains/sites/typings/Stage";

export const useVueStages = () => {
  const { vueStages } = useSnapshot(sitesPipelineStore);

  return vueStages as Stage[];
};
